import TimePickerComponent from '@/components/_custom/Picker/timePicker/timePicker'
import { FunctionComponent } from 'react'
import styles from './slotTimeFields.module.scss'
import { getDaycareClosing, getDaycareOpening } from '@/modules/helper/daycareHelper'
import moment from 'moment'
import { useCurrentDaycareInfos } from '@/hooks/useCurrentDaycareInfos'
import { t } from 'i18next'
import { DAYTIME_FORMAT, HOUR_MINUTE_FORMAT } from '../../../models/constants'

interface SlotTimeFieldsProps {
    startDate: string
    startTime: string
    setStartTime(value: string): void
    endTime: string
    setEndTime(value: string): void
    error?: boolean
}

const SlotTimeFields: FunctionComponent<SlotTimeFieldsProps> = ({
    startDate,
    startTime,
    setStartTime,
    endTime,
    setEndTime,
    error = false
}: SlotTimeFieldsProps) => {
    const { currentDaycare } = useCurrentDaycareInfos()

    const minHour: number = Number(
        moment(
            getDaycareOpening(currentDaycare, (moment(startDate, DAYTIME_FORMAT).day() + 6) % 7),
            HOUR_MINUTE_FORMAT
        ).format('HH')
    )
    const minMinute: number = Number(
        moment(
            getDaycareOpening(currentDaycare, (moment(startDate, DAYTIME_FORMAT).day() + 6) % 7),
            HOUR_MINUTE_FORMAT
        ).format('mm')
    )
    const maxHour: number = Number(
        moment(
            getDaycareClosing(currentDaycare, (moment(startDate, DAYTIME_FORMAT).day() + 6) % 7),
            HOUR_MINUTE_FORMAT
        ).format('HH')
    )
    const maxMinute: number = Number(
        moment(
            getDaycareClosing(currentDaycare, (moment(startDate, DAYTIME_FORMAT).day() + 6) % 7),
            HOUR_MINUTE_FORMAT
        ).format('mm')
    )

    const range: number = currentDaycare.merger ? Number(currentDaycare.bookRange.split('_')[1] || '15') : 15

    return (
        <div className={styles.Input}>
            <TimePickerComponent
                value={startTime}
                setValue={setStartTime}
                label={t('startHour')}
                className={styles.UserInput}
                minHour={minHour}
                minMinute={minMinute}
                maxHour={maxHour}
                maxMinute={maxMinute}
                endTime={
                    endTime
                        ? moment(endTime, HOUR_MINUTE_FORMAT).format(HOUR_MINUTE_FORMAT)
                        : moment().hours(maxHour).minutes(maxMinute).seconds(0).format(HOUR_MINUTE_FORMAT)
                }
                minuteToDisable={range}
                error={error}
            />
            <TimePickerComponent
                value={endTime}
                setValue={setEndTime}
                label={t('endHour')}
                className={styles.UserInput}
                minHour={minHour}
                minMinute={minMinute}
                maxHour={maxHour}
                maxMinute={maxMinute}
                startTime={
                    startTime
                        ? moment(startTime, HOUR_MINUTE_FORMAT).format(HOUR_MINUTE_FORMAT)
                        : moment().hours(minHour).minutes(minMinute).seconds(0).format(HOUR_MINUTE_FORMAT)
                }
                minuteToDisable={range}
                error={error}
            />
        </div>
    )
}

export default SlotTimeFields
